import { render, staticRenderFns } from "./bulkCargo.vue?vue&type=template&id=c3907104&scoped=true&"
import script from "./bulkCargo.vue?vue&type=script&lang=js&"
export * from "./bulkCargo.vue?vue&type=script&lang=js&"
import style0 from "./bulkCargo.vue?vue&type=style&index=0&id=c3907104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3907104",
  null
  
)

export default component.exports